var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: " heart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.81335 4C4.23735 4 3.69735 4.22267 3.29335 4.62733C2.45468 5.46733 2.45468 6.83467 3.29401 7.676L8.00001 12.39L12.7067 7.676C13.546 6.83467 13.546 5.46733 12.7067 4.62733C11.8987 3.81733 10.4747 3.81867 9.66668 4.62733L8.47201 5.824C8.22135 6.07533 7.77868 6.07533 7.52801 5.824L6.33335 4.62667C5.92935 4.22267 5.39001 4 4.81335 4ZM8.00003 14.0001C7.82336 14.0001 7.65336 13.9301 7.5287 13.8041L2.35003 8.61741C0.992698 7.25741 0.992698 5.04475 2.35003 3.68475C3.00603 3.02875 3.8807 2.66675 4.81336 2.66675C5.74603 2.66675 6.62136 3.02875 7.2767 3.68475L8.00003 4.40941L8.72336 3.68541C9.37936 3.02875 10.254 2.66675 11.1874 2.66675C12.1194 2.66675 12.9947 3.02875 13.65 3.68475C15.008 5.04475 15.008 7.25741 13.6507 8.61741L8.47203 13.8047C8.3467 13.9301 8.17736 14.0001 8.00003 14.0001Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.17b28c0ac3ef9827009cd5bdfddbe875.svg";
export { ForwardRef as ReactComponent };